import React from 'react';
import styled, { keyframes } from 'styled-components';

interface AnimatedTextProps {
  label: string;
  fontSize?: string;
}

// Define keyframes for the gradient animation
const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

// Styled component for the animated text
const AnimatedTextWrapper = styled.span<{ fontSize?: string }>`
  font-size: ${(props) => props.fontSize || '1rem'};
  font-weight: 600;
  background: linear-gradient(270deg, #ff6ec4, #7873f5, #4da6ff, #42d392);
  background-size: 400% 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${gradientAnimation} 4s ease infinite;
  display: inline-block;
`;

const AnimatedText: React.FC<AnimatedTextProps> = ({ label, fontSize }) => {
  return <AnimatedTextWrapper fontSize={fontSize}>{label}</AnimatedTextWrapper>;
};

export default AnimatedText;